import { ProgressFill, ProgressTrack } from './styles'

interface ProgressBarProps {
  /** 1-based 현재 step 인덱스 */
  current: number
  /** 전체 step 수 */
  total: number
}

export function ProgressBar({ current, total }: ProgressBarProps) {
  const ratio = Math.max(0, Math.min(1, current / total))
  return (
    <ProgressTrack>
      <ProgressFill style={{ width: `${ratio * 100}%` }} />
    </ProgressTrack>
  )
}
